import { TFunction } from 'i18next';

export const paymentAgreementPolyllmDefault = (t: TFunction): string =>
  t(
    'subscription:payment_form.agreement_polyllm-chat',
    'AV Wellbeing Limited, Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
  );

export const paymentAgreementPolyllmUs = (t: TFunction): string =>
  t(
    'subscription:payment_form.agreement_polyllm-chat_us',
    'TECHWAVE SOLUTIONS LIMITED, 9205 West Russell Road, Building 3, Suite 240, Las Vegas, NV 89148, USA',
  );
